import { Colors } from '../consts/Colors';

export default class Zone extends Phaser.GameObjects.Container {
    constructor(scene, zoneData) {
        super(scene, zoneData.finalX, zoneData.finalY, []);

        scene.add.existing(this);
        this.scene = scene;
        this.zoneData = zoneData;
        this.finalX = zoneData.finalX;
        this.finalY = zoneData.finalY;
        this.dZoneX = zoneData.dZoneX;
        this.dZoneY = zoneData.dZoneY;
        this.zoneId = zoneData.zoneId;

        this.labelDropped = undefined;

        this.isDone = false;

        this.dropZone = this.scene.add.rexRoundRectangle(0, 0, 343, 54, 25, Colors.Elmt.lightGrey).setOrigin(0.5);
        this.add(this.dropZone);
        this.setActive()

    }
    setActive() {
        this.setSize(this.dropZone.width, this.dropZone.height);
        this.setInteractive({ dropZone: true });
        // this.on('pointerover', () => {
        //     this.onPointerOver();
        // });
        // this.on('pointerout', () => {
        //     this.onPointerOut();
        // });
    }

    onPointerOver() {
        this.dropZone.setFillStyle(Colors.Elmt.DarkGrey);
    }
    onPointerOut() {
        this.dropZone.setFillStyle(Colors.Elmt.lightGrey);

    }
    dragOnPointerOver() {
        this.dropZone.setFillStyle(Colors.Elmt.DarkGrey);
    }
    dragOnPointerOut() {
        this.dropZone.setFillStyle(Colors.Elmt.lightGrey);

    }
    onDrop() {
        // this.disableInteractive()
        this.dropZone.setFillStyle(Colors.Elmt.lightGrey);
        this.isDone = true;

    }
    reset() {
        this.setActive()
        this.isDone = false;
        this.labelDropped = undefined;
    }

}